import HealthManager from './HealthManager';

export default HealthManager;
